import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';

const McpToolsVideo = observer((props) => {
  const {
    className = '',
    children,
    event,
  } = props;

  return (
    <div className={`mt-8px ${className}`} data-id={event?.planStepId}>
      <video 
        className="object-contain max-w-full max-h-80vh rounded-12px" 
        controls 
        preload="metadata"
        src={event.url + '#t=0.1'}>
      </video>
    </div>
  )
});
export default McpToolsVideo;